<script setup>
  import { watch } from "vue";
  import { storeToRefs } from "pinia";
  import { Card, CardContent } from "@/components/ui/card";
  import AudienceMap from "@/components/MCampaign/Audiences/AudienceMap.vue";
  import { useEstimateStore } from "@stores/mAudience/estimate";
  import { useMCampaignStore } from "@stores/mCampaign";

  const mCampaignStore = useMCampaignStore();
  const { getCampaignAdAccount } = storeToRefs(mCampaignStore);
  const estimateStore = useEstimateStore();
  const { mAudienceReachEstimate, getMAudienceTargets, reachEstimateError } = storeToRefs(estimateStore);
  const { fetchReachEstimate } = estimateStore;

  watch(getMAudienceTargets, async () => {
    await fetchReachEstimate();
  });
</script>

<template>
  <div class="sticky">
    <Card class="mb-4 p-4">
      <CardContent>
        <p class="text-xl! font-semibold">Reach estimate</p>
        <p
          v-if="getCampaignAdAccount === undefined"
          class="">
          Select a Facebook Ad Account
        </p>
        <p
          v-else-if="reachEstimateError"
          class="text-destructive">
          Calculation not possible with the specified criteria...
        </p>
        <h2
          v-else
          class="text-2xl font-bold">
          {{ mAudienceReachEstimate.toLocaleString() }} people
        </h2>
      </CardContent>
    </Card>
    <Card>
      <CardContent>
        <p class="text-xl! font-semibold pt-4 px-4">Audience map</p>
        <AudienceMap />
      </CardContent>
    </Card>
  </div>
</template>
